/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCLONEREASON } from './IAPCLONEREASON';
import {
    IAPCLONEREASONFromJSON,
    IAPCLONEREASONFromJSONTyped,
    IAPCLONEREASONToJSON,
} from './IAPCLONEREASON';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { IAPPRODUCTCONFIGURATIONCODE } from './IAPPRODUCTCONFIGURATIONCODE';
import {
    IAPPRODUCTCONFIGURATIONCODEFromJSON,
    IAPPRODUCTCONFIGURATIONCODEFromJSONTyped,
    IAPPRODUCTCONFIGURATIONCODEToJSON,
} from './IAPPRODUCTCONFIGURATIONCODE';
import type { IAPPROPOSALSTATUS } from './IAPPROPOSALSTATUS';
import {
    IAPPROPOSALSTATUSFromJSON,
    IAPPROPOSALSTATUSFromJSONTyped,
    IAPPROPOSALSTATUSToJSON,
} from './IAPPROPOSALSTATUS';
import type { ProductQuoteOverrideViewModel } from './ProductQuoteOverrideViewModel';
import {
    ProductQuoteOverrideViewModelFromJSON,
    ProductQuoteOverrideViewModelFromJSONTyped,
    ProductQuoteOverrideViewModelToJSON,
} from './ProductQuoteOverrideViewModel';
import type { StateModel } from './StateModel';
import {
    StateModelFromJSON,
    StateModelFromJSONTyped,
    StateModelToJSON,
} from './StateModel';

/**
 * 
 * @export
 * @interface ProposalInformationViewModel
 */
export interface ProposalInformationViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof ProposalInformationViewModel
     */
    isProposalLocked: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProposalInformationViewModel
     */
    selectedScenarioId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalInformationViewModel
     */
    partyId: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalInformationViewModel
     */
    partyName: string;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof ProposalInformationViewModel
     */
    partyType: IAPPARTYTYPE;
    /**
     * 
     * @type {StateModel}
     * @memberof ProposalInformationViewModel
     */
    stateModel: StateModel;
    /**
     * 
     * @type {IAPPROPOSALSTATUS}
     * @memberof ProposalInformationViewModel
     */
    status?: IAPPROPOSALSTATUS;
    /**
     * 
     * @type {IAPCLONEREASON}
     * @memberof ProposalInformationViewModel
     */
    cloneReason?: IAPCLONEREASON;
    /**
     * 
     * @type {Array<ProductQuoteOverrideViewModel>}
     * @memberof ProposalInformationViewModel
     */
    overrides?: Array<ProductQuoteOverrideViewModel>;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof ProposalInformationViewModel
     */
    productCode?: IAPPRODUCTCODE;
    /**
     * 
     * @type {IAPPRODUCTCONFIGURATIONCODE}
     * @memberof ProposalInformationViewModel
     */
    productConfigurationCode?: IAPPRODUCTCONFIGURATIONCODE;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalInformationViewModel
     */
    hasJustPortfolio: boolean;
}

/**
 * Check if a given object implements the ProposalInformationViewModel interface.
 */
export function instanceOfProposalInformationViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isProposalLocked" in value;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "partyName" in value;
    isInstance = isInstance && "partyType" in value;
    isInstance = isInstance && "stateModel" in value;
    isInstance = isInstance && "hasJustPortfolio" in value;

    return isInstance;
}

export function ProposalInformationViewModelFromJSON(json: any): ProposalInformationViewModel {
    return ProposalInformationViewModelFromJSONTyped(json, false);
}

export function ProposalInformationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalInformationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isProposalLocked': json['IsProposalLocked'],
        'selectedScenarioId': !exists(json, 'SelectedScenarioId') ? undefined : json['SelectedScenarioId'],
        'partyId': json['PartyId'],
        'partyName': json['PartyName'],
        'partyType': IAPPARTYTYPEFromJSON(json['PartyType']),
        'stateModel': StateModelFromJSON(json['StateModel']),
        'status': !exists(json, 'Status') ? undefined : IAPPROPOSALSTATUSFromJSON(json['Status']),
        'cloneReason': !exists(json, 'CloneReason') ? undefined : IAPCLONEREASONFromJSON(json['CloneReason']),
        'overrides': !exists(json, 'Overrides') ? undefined : ((json['Overrides'] as Array<any>).map(ProductQuoteOverrideViewModelFromJSON)),
        'productCode': !exists(json, 'ProductCode') ? undefined : IAPPRODUCTCODEFromJSON(json['ProductCode']),
        'productConfigurationCode': !exists(json, 'ProductConfigurationCode') ? undefined : IAPPRODUCTCONFIGURATIONCODEFromJSON(json['ProductConfigurationCode']),
        'hasJustPortfolio': json['HasJustPortfolio'],
    };
}

export function ProposalInformationViewModelToJSON(value?: ProposalInformationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IsProposalLocked': value.isProposalLocked,
        'SelectedScenarioId': value.selectedScenarioId,
        'PartyId': value.partyId,
        'PartyName': value.partyName,
        'PartyType': IAPPARTYTYPEToJSON(value.partyType),
        'StateModel': StateModelToJSON(value.stateModel),
        'Status': IAPPROPOSALSTATUSToJSON(value.status),
        'CloneReason': IAPCLONEREASONToJSON(value.cloneReason),
        'Overrides': value.overrides === undefined ? undefined : ((value.overrides as Array<any>).map(ProductQuoteOverrideViewModelToJSON)),
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
        'ProductConfigurationCode': IAPPRODUCTCONFIGURATIONCODEToJSON(value.productConfigurationCode),
        'HasJustPortfolio': value.hasJustPortfolio,
    };
}

